"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = void 0;

var tslib_1 = require("tslib");

var ui_helper_get_symbol_1 = require("@hopin-team/ui-helper-get-symbol");

var ui_helper_props_to_styles_1 = require("@hopin-team/ui-helper-props-to-styles");

var ui_symbols_1 = require("@hopin-team/ui-symbols");

var styled_components_1 = tslib_1.__importStar(require("styled-components"));

var makeScaleStyles = function makeScaleStyles(scale) {
  return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  height: ", ";\n  width: ", ";\n"], ["\n  height: ", ";\n  width: ", ";\n"])), (0, ui_symbols_1.calcSpace)(scale), (0, ui_symbols_1.calcSpace)(scale));
};

var flexibleStyles = "\n  height: 100%;\n  width: 100%;\n";

var makeColorStyles = function makeColorStyles(color, theme) {
  return (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), (0, ui_helper_get_symbol_1.getColor)(color, theme));
};

exports.Root = styled_components_1.default.div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['color', 'scale', 'isParentColor', 'isFlexible', 'colorTransition'].includes(prop);
  }
})(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  display: inline-flex;\n  ", "\n\n  ", "\n  ", "\n"], ["\n  display: inline-flex;\n  ", "\n\n  ", "\n  ", "\n"])), function (props) {
  return props.colorTransition && "transition: color 0.2s ease-in-out;";
}, function (props) {
  return !props.isFlexible ? (0, ui_helper_props_to_styles_1.makeStyles)(props, 'scale', makeScaleStyles) : flexibleStyles;
}, function (props) {
  return !props.isParentColor && (0, ui_helper_props_to_styles_1.makeStyles)(props, 'color', makeColorStyles);
});
var templateObject_1, templateObject_2, templateObject_3;